var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card note-wrap private-attach-wrap"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"meta"},[_c('div',{staticClass:"row"},_vm._l((_vm.privateAttachments),function(attachment){return _c('div',{staticClass:"medium-2"},[_c('all-bubble',{attrs:{"file":attachment}})],1)}),0)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }